<div class="resumen-documentos-generados">
  <p class="solicitud-line mb-3">
    Solicitud #:
    <strong>{{ solicitudNumero || '—' }}</strong>
  </p>

  <table class="table table-bordered table-sm mb-0 resumen-tabla">
    <thead>
      <tr>
        <th scope="col">Tipo de Documento</th>
        <th scope="col">Nombre de Documento</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let fila of filasResumen">
        <td>{{ fila.tipoDocumento }}</td>
        <td>{{ fila.nombreDocumento }}</td>
      </tr>
      <tr *ngIf="filasResumen.length === 0">
        <td colspan="2" class="text-center text-muted">
          No hay documentos generados para mostrar.
        </td>
      </tr>
    </tbody>
  </table>

  <ng-container *ngIf="enlaceFirma as enlace">
    <div *ngIf="enlace.enlaceCompleto" class="enlace-firma mt-3">
      <p class="mb-1"><strong>Enlace de firma</strong></p>
      <a
        [href]="enlace.enlaceCompleto"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ enlace.enlaceCompleto }}
      </a>
      <p *ngIf="enlace.fechaExpiracion" class="text-muted small mb-0 mt-1">
        Válido hasta: {{ enlace.fechaExpiracion }}
      </p>
    </div>
  </ng-container>

  <p *ngIf="errorEnlaceFirma" class="text-danger mt-3 mb-0">
    No se pudo generar el enlace de firma: {{ errorEnlaceFirma }}
  </p>
</div>
